<div class="panel panel-primary">
    <div class="panel-heading">Search</div>
    <div class="panel-body">
    <div class="form">
      <div class="form-group row">
        <label for="SupplierName" class="col-sm-2 col-form-label">Supplier Name:</label>
        <div class="col-sm-4">
          <input type="text"  [(ngModel)]="SupplierName" (keyup)="searchSupplier(SupplierName)"   placeholder="Supplier Name" name="SupplierName" class="form-control"
            id="SupplierName">
            <ul class="list-group" *ngIf="loading" >
              <li class="list-group-item" *ngFor="let _sup of results | async">
                <a style="cursor: pointer"  (click)="onselectSupplier(_sup)">{{_sup.SupplierName}}
                </a>
              </li>
            </ul>
        </div>
      </div>
  
      <div class="form-group row">
        <label for="ObjectAccount" class="col-sm-2 col-form-label">Object Account:</label>
        <div class="col-sm-4">
          <select id="ObjectAccount" class="form-control" [(ngModel)]="SelectedAcnt" name="ObjectAccount" >
            <option value="All" selected>All</option>
            <option *ngFor="let account of lstAccount" [ngValue]="account.ObjectAccount" >{{account.ObjectAccount}}  </option>
            </select>
          
        </div>
      </div>
      <div class="form-group row">
          <label for="Year" class="col-sm-2 col-form-label">Year:</label>
          <div class="col-sm-4">
              <input [(ngModel)]="Year"  placeholder="Year"  name="Year"
              class="form-control" id="Year">
            
          </div>
        </div>
        <div class="form-group row">
            <label for="Month" class="col-sm-2 col-form-label">Month:</label>
            <div class="col-sm-4">
                <input [(ngModel)]="Month"  placeholder="Month"  name="Month"
                class="form-control" id="Month">
              
            </div>
          </div>
         
      <div class="form-group row">
        <div class="col-sm-2 col-form-label"></div>
        <div class="col-sm-4">
          <button class="btn btn-primary" (click)="search()">Search</button>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  </div>
  